import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://mats2-ckb.mats.energy/api/v1/',
});

export default instance;
